<template>
  <div id="confirmacao-sucesso">
    <img class="align-middle" :src="require('@/assets/img/img_preparo_concluido.svg')"/>
    <span class="text-middle-big">Consulta Agendada</span>
    <div class="detalhe-consulta">
    <el-card class="card-info" :style="`background: ${corPrimaria}1A`">
      <el-row>
        <div>
      <el-col :span="4">
        <div>
          <small class="margin-btm">Paciente:</small>
        </div>
      </el-col>
        <el-col :span="20">
          <div class="card-item">
          <span class="bold-text">{{sucessoAgendamento.paciente.nome}}</span>
          <span class="regular-text">{{sucessoAgendamento.paciente.telefone}}</span>
          </div>
        </el-col>
        </div>
        <div div class="card-item">
          <el-col :span="4">
            <div>
              <small class="margin-btm">Médico:</small>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="card-item">
              <span class="bold">{{sucessoAgendamento.profissional.nome}}</span>
              <span class="regular-text">
                {{sucessoAgendamento.profissional.especialidade.descricao}} - {{sucessoAgendamento.profissional.conselho}}
              </span>
              <span class="sm-text-regular">{{labelTipoServico}}</span>
            </div>
          </el-col>
        </div>
        <div div class="card-item">
          <el-col :span="4">
            <div>
              <small class="margin-btm">Horário:</small>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="card-item">
              <span class="bold-text">
                {{formatDataHora(sucessoAgendamento.agenda.dataHora)}}
              </span>
            </div>
          </el-col>
        </div>
        <div v-if="idAgenda === '1'" class="card-item">
          <el-col :span="4">
            <div>
              <small class="margin-btm">Local:</small>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="card-item">
              <span class="bold-text">
                {{local.descricao}}
              </span>
              <span class="regular-text" v-html="fullEndereco(local.endereco)"></span>
            </div>
          </el-col>
        </div>
      </el-row>
    </el-card>
        <el-card class="protocolo-card">
          <div class="field">
            <small class="protocolo-title">PROTOCOLO</small>
            <span :style="`color: ${corPrimaria}`" class="text-blue-max">{{sucessoAgendamento.numeroProtocolo}}</span>
            <el-button type="text" @click="copiar" class="btn-icon"><inline-svg :fill="corPrimaria" :src="require('@/assets/icons/icon_btn_copy.svg')"></inline-svg></el-button>
          </div>
      </el-card>
      <el-button @click="goToHome" class="btn-principal" :style="`background:${corBtnPrincipal}`"><span :style="`color: ${corTextoBtnPrincipal}`">{{btnLabel}}</span></el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'
import moment from 'moment'
export default {
  data () {
    return {
      itensCard: {},
      itens: ['paciente', 'médico', 'horário', 'local']
    }
  },
  computed: {
    ...mapState('Func53', ['agendamento', 'idAgenda', 'local', 'paciente', 'sucessoAgendamento']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('Func53', ['tipoServico', 'idServico']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBtnPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBtnPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    btnLabel () {
      return this.funcionalidade.parametros.textos.labelBotaoConcluir
    },
    labelTipoServico () {
      if (this.idServico) {
        return this.tipoServico.find(item => item.idServico === this.idServico).descricao
      }
      return ''
    }
  },
  components: {
    inlineSvg
  },
  methods: {
    fullEndereco (endereco) {
      return `${endereco.cidade}, ${endereco.bairro}, ${endereco.endereco} </br> ${endereco.numero}`
    },
    formatDataHora (dataHora) {
      const data = moment(dataHora).format('DD/MM/YYYY')
      const hora = moment(dataHora).format('HH:mm')
      return `${data} - ${hora}`
    },
    copiar () {
      this.$clipboard(this.sucessoAgendamento.numeroProtocolo)
    },
    goToHome () {
      this.$router.push({ path: '/53' })
    }
  }
}
</script>
